module.exports = __webpack_public_path__ + "img/joyride-dual-run-womens-running.3dfca66e.png";